import {
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  HostListener,
  Input,
  Output
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IconSizeEnum } from '../../_enums/icon.enum';
import { SdButtonComponent } from '../buttons/button/button.component';
import { SdButtonIconComponent } from '../buttons/button-icon/button-icon.component';
import { SdIconComponent } from '../icons/icon/icon.component';
import { ThemesEnum } from '../../_enums/themes.enum';

@Component({
  selector: 'sd-chat',
  templateUrl: './chat.component.html',
  standalone: true,
  imports: [
    SdIconComponent,
    SdButtonIconComponent,
    SdButtonComponent,
    TranslateModule
  ]
})
export class SdChatComponent {
  constructor(private elRef: ElementRef) {}
  iconSize = IconSizeEnum;
  themesEnum = ThemesEnum;

  @HostBinding('class.is-midly-open')
  @Input()
  isMidlyOpen = false;

  @Output()
  launchChat = new EventEmitter<void>();

  @Output()
  closeChat = new EventEmitter<void>();

  @Output()
  openChat = new EventEmitter<void>();

  @HostListener('click')
  onClick() {
    if (!this.elRef.nativeElement.classList.contains('is-open')) {
      this.elRef.nativeElement.classList.add('is-open');
      this.openChat.emit();
    }
  }

  close(event) {
    event.stopPropagation();
    this.closeChat.emit();
    this.elRef.nativeElement.classList.remove('is-open');
  }

  onLaunchChat() {
    this.launchChat.emit();
  }
}
